import useArrayObject from "../../hooks/useArrayObject";
import {
  addPayment,
  getPayments,
  updatePayment,
} from "../../http/api/PaymentAPI.js";

const usePaymentAPI = (props) => {
  const payments = useArrayObject();

  async function get(params = {}) {
    try {
      const res = await getPayments(params);
      console.log(res);
      payments.setValue(res.listPaymentInfo);
      return res.listPaymentInfo;
    } catch {}
  }

  async function insert(newPayment) {
    try {
      const res = await addPayment(newPayment);
      console.log(res);
      payments.unshift({ ...newPayment, paymentId: res });
      return res;
    } catch {}
  }

  async function update(newPayment) {
    try {
      const res = await updatePayment(newPayment);
      payments.updateByKey("paymentId", newPayment);
      console.log(res);
      return res;
    } catch {}
  }

  return { get, insert, update, Value: payments.Value };
};
export default usePaymentAPI;
